module.exports = __webpack_public_path__ + "static/media/sicbokm.9bfe76c5.jpeg";